import { PaginatedConnection } from 'src/app/core/type-helpers/paginated-connection';

export const COMMERCIAL_OPERATIONAL_NOTE_SORT_FIELDS = [
  'updatedAt',
  'facilityName',
  'facilityId',
  'category',
  'aorName',
  'contactName',
] as const;

export type CommercialOperationalNoteSortField =
  (typeof COMMERCIAL_OPERATIONAL_NOTE_SORT_FIELDS)[number];

export interface CommercialOperationalNoteSortOrQuery {
  startDate?: string;
  endDate?: string;
  businessUnits?: string[];
  updatedAt?: string;
  facilityName?: string;
  facilityId?: string;
  category?: string;
  aorName?: string;
  contactName?: string;
  comments?: string;
}

export interface CommercialOperationalNote {
  id: string;
  commercialFacilityId: string;
  facilityName: string;
  facilityId: string;
  category: string;
  aorId: string;
  aorName: string;
  businessUnitId: string;
  businessUnitName: string;
  commercialContactId: string | null;
  contactName: string | null;
  comments: string | null;
  createdAt: Date;
  updatedAt: Date;
  createdBy: string;
  updater: string;
  flexStart: Date | null;
  flexEnd: Date | null;
  flexType: string | null;
  flexAmount: string | null;
  deletedAt: Date | null;
  version: number;
}

export interface CommercialOperationalNoteSearch {
  id: string;
  facilityName: string;
  facilityId: string;
  category: string;
  aorName: string;
  contactName: string | null;
  comments: string;
  updatedAt: Date;
  flexStart: Date | null;
  flexEnd: Date | null;
  flexType: string | null;
  flexAmount: string | null;
}

export type CommercialOperationalNoteSearchConnection =
  PaginatedConnection<CommercialOperationalNoteSearch>;
